











































































import { isNull } from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { FieldUpdate } from './types';

const Props = Vue.extend({
	props: {
		popinUpdateAuto: {
			type: Boolean,
			default: false
		},
		fieldUpdates: {
			type: Array,
			required: true
		},
		updateOk: {
			type: Boolean,
			required: true
		},
		isErreur: {
			type: Boolean,
			required: true
		},
		codeErreur: {
			type: String,
			required: true
		}
	}
});
@Component({
	model: {
		prop: 'popinUpdateAuto',
		event: 'change'
	}
})

export default class PopinUpdateAuto extends Props {

	get computedValue(): boolean {
		return this.popinUpdateAuto;
	}

	set computedValue(popinUpdateAuto: boolean) {
		this.$emit('change', popinUpdateAuto);
	}

	onClickValid(): void {
		this.computedValue = false;
	}

	get updateMessage(): string {
		return ((this.fieldUpdates || []) as FieldUpdate[])
			.filter((fieldUpdate) => !isNull(fieldUpdate.libelle))
			.map((fieldUpdate) => fieldUpdate.libelle + ' : ' + fieldUpdate.value)
			.join(', ');
	}

	get isUpdateNoChange() {
		return (this.isErreur && this.codeErreur === 'MAJ5');
	}

}
